function parseDateSafe(value) {
  if (!value) return null;
  const dt = new Date(value);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function getActiveEntitlementEndDate(user, now = new Date()) {
  const expiresAt = parseDateSafe(user?.entitlements?.expires_at);
  return userHasActiveEntitlement(user, now) ? expiresAt : null;
}

export function userHasActiveEntitlement(user, now = new Date()) {
  void now;
  return Boolean(user?.entitlements?.has_access);
}

export function userHasPaidEntitlement(user, now = new Date()) {
  void now;
  return Boolean(user?.entitlements?.subscription_active);
}
